import { Typography } from '@chr/eds-react';
import './../itemDetails/ItemDetailsInfo.scss';
import { Stack } from '@mui/material';
import { Measurement } from '../../common/apis/dtos';

interface ItemDetailsInfoProps {
  title: string;
  information: string | number | Measurement;
  isMobileScreen: boolean;
}

export const ItemDetailsInfo = ({
  title,
  information,
  isMobileScreen,
}: ItemDetailsInfoProps) => {
  return (
    <div
      data-testid="item-details-info-container"
      className={
        isMobileScreen
          ? 'item-details-info-container-mobile'
          : 'item-details-info-container'
      }
    >
      <Stack
        direction={isMobileScreen ? 'row' : 'column'}
        justifyContent={isMobileScreen ? 'space-between' : 'flex-start'}
        spacing={isMobileScreen ? 2 : 1}
        width={'100%'}
      >
        <Typography variant="body1">{title}</Typography>
        <Typography variant="subtitle2">{information}</Typography>
      </Stack>
    </div>
  );
};
